import { render } from "./equpmentmaintainance.vue?vue&type=template&id=520c7262"
import script from "./equpmentmaintainance.vue?vue&type=script&lang=js"
export * from "./equpmentmaintainance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__